import { useCallback, useMemo, useState } from "react";
import { FullscreenModal } from "../components/FullscreenModal";

interface OpenOptions {
  title?: string;
}

export function useFullscreenIframe(defaultTitle = "Preview") {
  const [state, setState] = useState<{ url: string; title?: string } | null>(
    null
  );

  const open = useCallback((url: string, options?: OpenOptions) => {
    if (!url) return;
    setState({ url, title: options?.title });
  }, []);

  const close = useCallback(() => {
    setState(null);
  }, []);

  const Modal = useMemo(
    () => () =>
      state ? (
        <FullscreenModal
          url={state.url}
          title={state.title ?? defaultTitle}
          onClose={close}
        />
      ) : null,
    [state, defaultTitle, close]
  );

  return {
    open,
    close,
    Modal,
    isOpen: Boolean(state),
    current: state,
  };
}
